export const cloneFiles = (files = []) => files.map((file) => ({ ...file }));

export const cloneRecords = (records = []) =>
    records.map((provider) => ({
        ...provider,
        source: Array.isArray(provider?.source) ? cloneFiles(provider.source) : provider?.source
    }));

export const getFileId = (providerId, file, fallbackIndex) =>
    `${providerId}::${file?.s3UrlPath ?? `${file?.name ?? 'file'}-${fallbackIndex}`}`;

export const findDragIndex = (array, getId, activeId, overId) => ({
    oldIndex: array.findIndex((item, i) => getId(item, i) === activeId),
    newIndex: array.findIndex((item, i) => getId(item, i) === overId),
});

export const findFileIndex = ({ source, providerId, fileId }) =>
    source.findIndex((file, sourceIndex) => getFileId(providerId, file, sourceIndex) === fileId);

export const getNextIndex = ({ fileIndex, direction, sourceLength }) => {
    const nextIndex = direction === 'up' ? fileIndex - 1 : fileIndex + 1;
    return nextIndex < 0 || nextIndex >= sourceLength ? null : nextIndex;
};

export const extractFileFromProvider = ({ medicalFiles, fileId, getProviderId }) => {
    let movedFile = null;
    let fromProviderIndex = -1;
    const afterRemove = medicalFiles.map((provider, index) => {
        const pid = getProviderId(provider, index);
        const fileIndex = provider.source.findIndex((f, fi) => getFileId(pid, f, fi) === fileId);
        if (fileIndex === -1) return provider;
        fromProviderIndex = index;
        movedFile = provider.source[fileIndex];
        return { ...provider, source: provider.source.filter((_, i) => i !== fileIndex) };
    });
    return { afterRemove, movedFile, fromProviderIndex };
};

export const updateSourceReorder = ({ medicalFiles, providerId, getReorderedSource, getProviderId }) => {
    let providerIndex = -1;
    let reorderedSource = null;
    const updated = medicalFiles.map((provider, index) => {
        if (getProviderId(provider, index) !== providerId) return provider;
        providerIndex = index;
        reorderedSource = getReorderedSource(provider.source);
        if (!reorderedSource) return provider;
        return { ...provider, source: reorderedSource };
    });
    return { updated, providerIndex, reorderedSource };
};

export const resolveFileDragProviders = ({ medicalFiles, activeId, overId, getProviderId }) => {
    let fromProviderId = null;
    let toProviderId = null;
    medicalFiles.forEach((provider, index) => {
        const pid = getProviderId(provider, index);
        if (provider.source.some((file, fi) => getFileId(pid, file, fi) === activeId)) fromProviderId = pid;
        if (provider.source.some((file, fi) => getFileId(pid, file, fi) === overId)) toProviderId = pid;
        if (pid === overId) toProviderId = pid;
    });
    return { fromProviderId, toProviderId };
};

export const insertFileIntoProvider = ({ medicalFiles, toProviderId, movedFile, getProviderId }) => {
    let toProviderIndex = -1;
    const afterInsert = medicalFiles.map((provider, index) => {
        if (getProviderId(provider, index) !== toProviderId) return provider;
        toProviderIndex = index;
        return { ...provider, source: [...provider.source, movedFile] };
    });
    return { afterInsert, toProviderIndex };
};